module.exports = window.$;